import styled, { css } from 'styled-components';

export const StyledRuleBuilderContainer = styled.div<{ renderLines: boolean }>`
  position: relative;
  width: 100%;
  min-height: 100%;

  ${({ renderLines }) => renderLines && css`
  &:before {
      display: block;
      content: '';
      width: 26px;
      position: absolute;
      background: var(--cl-gray-100);
      height: 100%;
      z-index: -1;
    }
  `}
`;

export const StyledActionInfoContainer = styled.div`
  margin-left: var(--cl-space-6);
  margin-right: var(--cl-space-6);
  margin-top: var(--cl-space-3);
  padding-bottom: var(--cl-space-5);
`;
